import React, { Component } from "react";
import {
	formatPhoneNumber,
	formatZipcode,
	formatUrl
} from "./../modules/formattingHelpers";

export default class OrganizationCard extends Component {
	constructor(props) {
		super(props);
	}
	renderAddress() {
		return (
			<address>
				{this.props.organization.acf.pp_gids_street ? (
					<span>
						{this.props.organization.acf.pp_gids_street}{" "}
						{this.props.organization.acf.pp_gids_house_number}
						{this.props.organization.acf.pp_gids_suite},{" "}
						{formatZipcode(this.props.organization.acf.pp_gids_zip_code)}{" "}
						{this.props.organization.acf.pp_gids_city}
					</span>
				) : null}
				{this.props.organization.acf.pp_gids_phone_number ? (
					<span>
						{" "}
						&#183;{" "}
						{formatPhoneNumber(
							this.props.organization.acf.pp_gids_phone_number
						)}{" "}
					</span>
				) : null}{" "}
				{this.props.organization.acf.pp_gids_mobile_phone_number ? (
					<span>
						{" "}
						&#183;{" "}
						{formatPhoneNumber(
							this.props.organization.acf.pp_gids_mobile_phone_number
						)}{" "}
					</span>
				) : null}{" "}
				{this.props.organization.acf.pp_gids_url ? (
					<span>
						{" "}
						&#183; {formatUrl(this.props.organization.acf.pp_gids_url)}{" "}
					</span>
				) : null}
			</address>
		);
	}

	render() {
		return (
			<li className="listing__item" key={this.props.organization.id}>
				<div className="organization-card__url">
					<div
						className="organization-card"
						onClick={e =>
							window.open(this.props.organization.guid.rendered, "_self")
						}
					>
						<header className="organization-card__header">
							<h2 className="organization-card__title">
								<a href={this.props.organization.link}>
									<span
										dangerouslySetInnerHTML={{
											__html: this.props.organization.title.rendered
										}}
									></span>
									<span
										className="screen-reader-text"
									>Lees meer</span>
									{this.props.organization.acf.pp_provided_care ? (
										<span className="organization-card__provided_care__icon"></span>
									) : null}
								</a>
							</h2>
						</header>

						{this.renderAddress()}

						<div
							className="organization-card__description"
							dangerouslySetInnerHTML={{
								__html: this.props.organization.excerpt.rendered
							}}
						></div>

						<span className="organization-card__readmore" aria-hidden="true">
							Lees meer
						</span>
					</div>
				</div>
			</li>
		);
	}
}
